import React from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

/**
 * Global marquee/running text — mounted once at bottom of the page.
 * Text is set by super_admin in Admin → Pengaturan. Empty text → hidden.
 * Hidden on /admin/* pages (only for public-facing views).
 */
export default function MarqueeBar() {
    const { pathname } = useLocation();
    const { settings } = useSettings();
    const text = (settings?.marquee_text || "").trim();
    if (!text || pathname.startsWith("/admin") || pathname.startsWith("/rp-console")) return null;
    // Repeat text a few times to fill the strip nicely and enable seamless loop
    const separator = "   •   ";
    const looped = Array(4).fill(text).join(separator);
    return (
        <div
            data-testid="marquee-bar"
            className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-primary text-primary-foreground overflow-hidden select-none"
            aria-live="off"
        >
            <div
                className="whitespace-nowrap py-2 text-xs sm:text-sm font-medium tracking-wide"
                style={{
                    animation: "marquee-scroll 40s linear infinite",
                    willChange: "transform",
                }}
            >
                {looped}{separator}{looped}
            </div>
            <style>{`
                @keyframes marquee-scroll {
                    0%   { transform: translateX(0%); }
                    100% { transform: translateX(-50%); }
                }
            `}</style>
        </div>
    );
}
